module.exports = __webpack_public_path__ + "img/icon-sell@3x.8b44b7a0.png";